import stepMixin from './mixins/stepMixin'
import { RecaptchaMixin } from "./mixins/RecaptchaMixin";
import FormWizard from './components/FormWizard'

export default {
  install( Vue, options ) {

    let formController = new Vue({
      mixins: [
        RecaptchaMixin
      ],
      data: {
        currentStep: 0,
        loading: false,
        steps: []
      },
      computed: {
        currentStepValid() {
          return this.steps[this.currentStep].valid
        },
        totalSteps() {
          return this.steps.length
        },
        progress() {
          let stepsCompleted = 0
          for (let step of this.steps) {
            if (step.valid) {
              stepsCompleted++
            }
          }
          const percentage = stepsCompleted / this.steps.length * 100
          return percentage
        },
        wizardValid() {
          for (let step of this.steps) {
            if (!step.valid) {
              return false
            }
          }
          return true
        }
      },
      methods: {
        async nextStep() {
          //We cannot go beyond the last step
          if (this.currentStep === this.steps.length-1) {
            return false
          }
          //Move to the next step only if the current step is valid
          if (!this.currentStepValid) {
            this.loading = true
            try {
              await this.checkStepValidation()
              this.currentStepValid = true
              this.loading = false
            } catch (error) {
              this.currentStepValid = false
              this.loading = false
              return false
            }
          }
          this.currentStep++
        },
        prevStep() {
          //We cannot go back past the first step
          if (this.currentStep === 0) {
            return false
          }
          this.currentStep--
        },
        isFirstStep() {
          if (this.currentStep === 0) {
            return true
          }
          return false
        },
        isLastStep() {
          if (this.currentStep === this.steps.length-1) {
            return true
          }
          return false
        },
        stepEnabled(stepIndex) {
          if (stepIndex === 0) {
            return true
          }
          if (this.steps[stepIndex-1].valid) {
            return true
          } else {
            return false
          }
        },
        async submit() {
          this.loading = true
          if (!this.currentStepValid) {
            try {
              await this.checkFormValidation()
            } catch (error) {
              this.loading = false
              return false
            }
          }
          //Call the submit callback function which should be set on final step creation
          try {
            await this.$submitCallback()
          } catch (error) {
            this.loading = false
            return false
          }
        },
        setCurrentStepValidation(val) {
          this.steps[this.currentStep].valid = val
        },
        checkStepValidation() {
          return new Promise((resolve, reject) => {
            setTimeout((resolve) => {
              resolve()
            }, 1000, resolve)
          })
        },
        checkFormValidation() {
          return new Promise((resolve, reject) => {
            setTimeout((resolve) => {
              resolve()
            }, 2000, resolve)
          })
        },
      },
      created() {
        // Initialise the steps
        this.steps = options.steps.reduce((steps, step) => {
          step.valid = false
          steps.push(step)
          return steps
        }, [])
      }
    })
    Vue.prototype.$formController = formController

    //Components
    Vue.component('form-wizard', FormWizard)

    // Dynamically import component steps
    for (let step of options.steps) {
      Vue.component(step.component, async () => {
        const component = await import(/* webpackMode: "eager" */ '@/components/steps/' + step.component)
        component.default.mixins = [stepMixin] //Add the step mixin to each step provided by the user
        return component
      })
    }
      
    Vue.prototype.$wizardConfig = options

  }
}